import { authSlice } from "@/entities/session";
import { skuSectionSlice } from "@/entities/sku-section";
import { planogramSlice } from "@/entities/planogram";
import { gatewayApi, insightsApi, streamsApi } from "@/shared/api";
import { combineReducers } from "@reduxjs/toolkit";
import { lodApi } from "@/shared/api/lod-api";
import { annotationSlice } from "@/entities/annotation";
import { proximitySlice } from "@/entities/proximity";
import { gondolaChangeGroupsSlice } from "@/entities/gondola-change-groups/model/slice";

export const rootReducer = combineReducers({
  [authSlice.name]: authSlice.reducer,
  [skuSectionSlice.name]: skuSectionSlice.reducer,
  [planogramSlice.name]: planogramSlice.reducer,
  [annotationSlice.name]: annotationSlice.reducer,
  [proximitySlice.name]: proximitySlice.reducer,
  [gondolaChangeGroupsSlice.name]: gondolaChangeGroupsSlice.reducer,

  // RTK Query reducers
  [gatewayApi.reducerPath]: gatewayApi.reducer,
  [insightsApi.reducerPath]: insightsApi.reducer,
  [streamsApi.reducerPath]: streamsApi.reducer,
  [lodApi.reducerPath]: lodApi.reducer,
});
